import { styled } from "@mui/material/styles";

export const FooterContainer = styled("div")<{
  leftMargin?: number | string;
}>(({ leftMargin = 0 }) => ({
  position: "relative",
  marginLeft: leftMargin,
  width: `calc(100% - ${leftMargin}px)`,
  minHeight: "60px",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "0px 24px",
  backgroundColor: "#F9FAFB",
  boxShadow: "1px 0 3px 0 rgba(71, 84, 103, 0.30), 0 4px 8px 3px rgba(71, 84, 103, 0.15)",
}));

export const PoweredContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

export const PoweredText = styled("span")(() => ({
  color: "#98A2B3",
  textAlign: "center",
  fontFamily: "Manrope",
  fontSize: "10px",
  fontWeight: 400,
  lineHeight: "12px",
  letterSpacing: "0.5px",
  marginLeft: "10px",
}));

export const TermsText = styled("span")(() => ({
  color: "#98A2B3",
  textAlign: "right",
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: "0.1px",
  cursor: "pointer",
}));
